window.RankedList = {

	init: function(){
		$('.valueList ').sortable({
			handle		: 'a.drag',
			items		: 'tr:not(.noDrag)',
			opacity		: 0.8,
			axis		: 'y',
			stop		: function(event, ui) {RankedList.updateRank();},
			containment	: 'parent',
			tolerance	: 'pointer',
			cursor		: 'move'
		});

		RankedList.initEvent('body');

		$('.colorPicker').colpick({
			layout		: 'hex',
			submit		: 0,
			colorScheme	: 'light',
			onChange	: function(hsb, hex, rgb, el, bySetColor) {

				$(el).parent().find('.append').css('background-color','#'+hex);
				// Fill the text box just if the color was set using the picker, and not the colpickSetColor function.
				$(el).val(hex);
			}
		}).unbind('keyup').keyup(function(){
			$(this).colpickSetColor(this.value);
		}).trigger('keyup');

		Qtip.init();

	},

	initEvent: function(element){

		element = undefined==element ? 'body' : element;

		$('.valueList input[type=checkbox]', element).each(function(){
			var checkbox = this;
			$(checkbox).click(function(){
				var row = $(checkbox).parent().parent();
				if($(checkbox).prop('checked')) {
					$(row).removeClass('disable');
					$(row).addClass('enable');
				}else {
					$(row).removeClass('enable');
					$(row).addClass('disable');
				}
			}) ;
		});

		MyFacture.initEvent(element);

	},

	confirmDeletion: function(prefix, rowId) {

		// RESET ALREADY DEL CONFIRM DISPLAYED
		$("[id*="+prefix+"del_]").show();
		$("[id*="+prefix+"del_conf_]").hide();

		if( $("#"+prefix+"form tr.enable").length > 1 || !$('#'+prefix+"isEnabled_"+rowId).is(':checked')) {
			// DISPLAYED DEL CONFIRM FOR THE ROW
			$("#"+prefix+"del_"+rowId).hide();
			$("#"+prefix+"del_conf_"+rowId).show();
			MyFacture.customForm("#"+prefix+"del_conf_"+rowId);
		} else {
			// DISPLAYED DEL IMPOSSIBLE INFORMATION FOR THE ROW
			$("#"+prefix+"del_"+rowId).hide();
			$("#"+prefix+"del_conf_impossible_"+rowId).show();
		}

	},

	deleteIt: function(prefix, rowId){
		$('#'+prefix+"row_"+rowId).remove();
	},

	cancelDeletion: function(prefix, rowId){
		$("#"+prefix+"del_conf_"+rowId).hide();
		$("#"+prefix+"del_"+rowId).show();
	},

	updateRank: function(){
		var rank=1;
		 $('.valueList .rankForm').each(function(){
			 $(this).val(rank);
			 rank++;
		 });
	},

	add: function(prefix){

		var nbElement =  parseInt($('.valueList #'+prefix+'form').attr('nbelement'));
		nbElement = isNaN(nbElement) ? 0 : nbElement;
		var parent = $('.valueList #'+prefix+'template tbody');
		var position = nbElement+1;

		var content = Text.replace($(parent).html(), "JS_POSITION", position);
		$('.valueList #'+prefix+'form').attr('nbelement', position);
		$('.valueList #'+prefix+'form').append(content);
		var rowid = "#"+prefix+"row_"+position;
		MyFacture.customForm(rowid);
		RankedList.initEvent(rowid);
		RankedList.updateRank();

		$('.colorPicker').colpick({
			layout		: 'hex',
			submit		: 0,
			colorScheme	: 'light',
			onChange	: function(hsb, hex, rgb, el, bySetColor) {

				$(el).parent().find('.append').css('background-color','#'+hex);
				// Fill the text box just if the color was set using the picker, and not the colpickSetColor function.
				$(el).val(hex);
			}
		}).unbind('keyup').keyup(function(){
			$(this).colpickSetColor(this.value);
		}).trigger('keyup');

	},

	editItemsList: function(listName, numformat, more, customCallback){

		var title = "";
		more = undefined==more ? "" : more;
		customCallback = undefined==customCallback ? "" : customCallback;

		if("shippings"==listName){
			title = Loc.g("Liste des transporteurs");
		}

		if("packagings"==listName){
			title = Loc.g("Liste des emballages");
		}

		var options = {
			title	: title,
			buttons	: [
                {text : Loc.g("Annuler"), click : function(){$(this).dialog("close")}}		,
                {text : Loc.g("Enregistrer"), click : function(){$("#itemsListForm").submit();}}
			],
			width: 1200,
			callback	: function(){RankedList.prepareItemsListForm(listName, numformat, more, customCallback);}
		};

		var fileOpt = {action:"itemsListForm", listName:listName};
		fileOpt = $.extend(true, fileOpt, numformat);
		MyWindow.load("rankedlist", fileOpt, options);

	},

	prepareItemsListForm: function(listName, numformat, more, customCallBack){

		var lang = $("#docLang").val() != undefined ? $("#docLang").val() : 0;

		var formId = "itemsListForm";
		var options = {
			success: function(data){
				RankedList.recordItemsListCallback(data, more, customCallBack);
			},
			dataType:"json"
		};

		var params = {
			action		: 'recordItemsList',
			listName	: listName,
			more 		: more,
			from 		: Utils.exists("docid") ? "doc" : "prefs",
			lang		: lang
		};

		params = $.extend(true, params, numformat);
		MyForm.prepare(formId, "rankedlist&"+$.param(params), options, true);

		// translation tabs
		MyTabs.initHorizontal();

		RankedList.init();
		RankedList.updateRank();

		$('#'+formId+' input[type=checkbox]').click(function(event){
			if ($('#'+formId+' input.enableToggler[type=checkbox]:checked').length < 1){
				MyWindow.alert(Loc.g('Vous ne pouvez pas désactiver toutes vos entrées. Veuillez en sélectionner une.'), {type: 'error'});
				return false;
			}
		});

		var tmpContent = $('[id$=_row_JS_POSITION]').html();
		tmpContent = Text.replace(tmpContent, "sellAccountingCode_1", "sellAccountingCode_JS_POSITION");
		tmpContent = Text.replace(tmpContent, "purAccountingCode_1", "purAccountingCode_JS_POSITION");
		$('[id$=_row_JS_POSITION]').html(tmpContent);
	},

	recordItemsListCallback: function(data, more, customCallback){

		if(data.form.status != 'ok' && data.form.msg != ""){
			MyWindow.alert(data.form.msg, {
				type :		'error',
				buttons : 	[{
					text: Loc.g("Ok"),
					click: function(){
						$(this).dialog("close");
					}}]
			});
		}

		if(typeof eval(customCallback) == 'function'){
			eval(customCallback)(data);
		}

	},

	editValuesList: function(listName, numformat, format, more, customCallback){

		var title		= "";
		more			= undefined==more ? "" : more;
		format			= undefined==format ? "" : format;
		customCallback	= undefined==customCallback ? "" : customCallback;

		switch(listName){
			case 'units':
				title = Loc.g("Unités");
				break;
			case 'taxes':
				title = Loc.g("Taxes");
				break;
			case 'paydates' :
				title = Loc.g("Délais de paiement");
				break;
			case 'paymediums':
				title = Loc.g("Moyens de paiement");
				break;
			case 'paycheckorders':
				title = Loc.g("Libellés de chèques");
				break;
			case 'labels':
				title = Loc.g("Labels des tâches et évènements");
				break;
			case 'docspeakers':
				title = Loc.g("Libellé de votre interlocuteur");
				break;
			case 'projectentrylabels':
				title = Loc.g('Labels des entrées de projet');
				break;
			case 'phonecalltypes':
				title = Loc.g('Labels des sujets d‘appel');
				break;
		}

		var options = {
			title	: title,
			buttons	: [
				{
					text	: Loc.g("Annuler"),
					click	: function(){
						$(this).dialog("close");
					}
				},
				{
					text	: Loc.g("Enregistrer"),
					click	: function(){
						$("#valuesListForm").submit();
					}
				}
			],
			height : 500,
			width : 650,
			callback	: function(){
				RankedList.prepareValuesListForm(listName, numformat, more, customCallback);
			}
		};

		MyWindow.load("rankedlist", {action : "valuesListForm", listName : listName}, options);
	},

	prepareValuesListForm: function(listName, numformat, more, customCallback){

		var lang	= $("#docLang").val() != undefined ? $("#docLang").val() : 0;
		var formId	= "valuesListForm";
		var forceFormat;

        if ($('#'+listName+"forcedFormat").length === 1){
            forceFormat = $('#'+listName+"forcedFormat").html();
        } else {
            forceFormat = 'no';
        }

		var options = {
			success		: function(data){
				RankedList.recordValuesListCallback(data, more, customCallback);
			},
			dataType	: "json"
		};

		var params = {
			action		: 'recordValuesList',
			listName	: listName,
			forceformat	: forceFormat,
			more		: more,
			from		: Utils.exists("docid") ? "doc" : "prefs",
			lang		: lang
		};

		params = $.extend(true, params, numformat);
		MyForm.prepare(formId, "rankedlist&"+$.param(params), options, true);

		// translation tabs
		MyTabs.initHorizontal();

		RankedList.init();
		RankedList.updateRank();

		$('#'+formId+' input[type=checkbox]').click(function(event){
			if ($('#'+formId+' input[type=checkbox]:checked').length === 1){
				MyWindow.alert(Loc.g('Vous ne pouvez pas désactiver toutes vos entrées. Veuillez en sélectionner une.'), {type: 'error'});
				return false;
			}
		});

	},

	recordValuesListCallback: function(data, more, customCallback){
		if (data.form.status != 'ok' || data.form.msg != "") {
			if (data.form.msg != "") {
				MyWindow.alert(data.form.msg, { type: 'error' });
			}
		} else {
			Utils.reload();
		}

		if (typeof eval(customCallback) == 'function') {
			eval(customCallback)(data);
		}
	},

	checkRiskAwareness: function () {
		$("#risk-awareness").prop("checked") ?
			$(".ui-dialog-buttonset .btn-danger").removeClass("btn-disabled")
			:
			$(".ui-dialog-buttonset .btn-danger").addClass("btn-disabled");
	},

	deleteBankAccount: function (bankAccountId) {
		var options = {
			dialogClass: "white no-title",
			resizable: false,
			noclose: false,
			title: Loc.g("Suppression de compte bancaire"),
			buttons: [
				{
					text: Loc.g("Supprimer le compte"),
					'class': "btn btn-danger btn-disabled",
					click: function () {
						let options = {
							'action': 'bankAccountDelete',
							'baid': bankAccountId
						};

						if ($("#risk-awareness").prop("checked")) {

							MyFacture.post("bankaccount", options, function () {
								Utils.reload()
							}, "json");
						}
					}
				}
			]
		};

		let fileOpt = {action: "deleteBankAccountForm"};
		MyWindow.load("bankAccountPreferences", fileOpt, options);
	},

	checkSameTax : function(e){

		var value_formatted = NumberFormat.formatToFloat($(e.currentTarget).val(), NumberFormat.loadFromInputs('num_')).toFixed(9);
		var res = $('#vl_tax_form').find("input[value='"+value_formatted+"']").val();

		if(res !== undefined){
			var options = {
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Taux TVA"),
			type		: "warning",
			buttons		: [
				{text : Loc.g("OK"), click : function(){$(this).dialog("close");}}
			]
			};
			MyWindow.alert(Loc.g("Attention : Vous souhaitez créer un taux de TVA qui est déjà présent dans votre compte.<br/>Cette action pourrait engendrer des problèmes lors des exports comptables."), options);
		}
	}
};
